import http from '@/utils/http'

export function getGrades(params){
    return  http('/grades',{params})
}

export function getGradesDetail(id){
    return  http(`/grades/${id}`)
}

export function getPurchaseHistories(){
    return  http('/purchase_histories')
}